export default __webpack_public_path__ + "static/media/camisa.7d1fa18b.jpg";